import { render, staticRenderFns } from "./CreateCustomer.vue?vue&type=template&id=6c8bf99e&scoped=true&"
import script from "./CreateCustomer.vue?vue&type=script&lang=js&"
export * from "./CreateCustomer.vue?vue&type=script&lang=js&"
import style0 from "./CreateCustomer.vue?vue&type=style&index=0&id=6c8bf99e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8bf99e",
  null
  
)

export default component.exports